import type { IconKey, IconType } from '../theme/themes/ThemeTypes';

import Connection from './Icon/Connection';
import DeleteAccount from './Icon/DeleteAccount';
import Elec from './Icon/Elec';
import Finance from './Icon/Finance';
import Help from './Icon/Help';
import Notification from './Icon/Notification';
import Overview from './Icon/Overview';
import Password from './Icon/Password';
import Profile from './Icon/Profile';
import Settings from './Icon/Settings';
import Solar from './Icon/Solar';
import Tariff from './Icon/Tariff';
import TDAS from './Icon/TDAS';

type IconProps = {
  icon: IconType | IconKey;
  colour: string;
} & React.SVGProps<SVGSVGElement>;

// Available icon keys for error messages
const AVAILABLE_ICON_KEYS: IconKey[] = [
  'connection',
  'elec',
  'finance',
  'help',
  'notification',
  'overview',
  'profile',
  'tariff',
  'tdas',
  'password',
  'delete-account',
  'solar',
  'settings',
];

const Icon = ({ icon, colour, ...props }: IconProps) => {
  // If it's a component
  if (typeof icon === 'function') {
    const IconComponent = icon;
    return <IconComponent colour={colour} {...props} />;
  }

  switch (icon) {
    case 'connection':
      return <Connection colour={colour} {...props} />;
    case 'elec':
      return <Elec colour={colour} {...props} />;
    case 'finance':
      return <Finance colour={colour} {...props} />;
    case 'help':
      return <Help colour={colour} {...props} />;
    case 'notification':
      return <Notification colour={colour} {...props} />;
    case 'overview':
      return <Overview colour={colour} {...props} />;
    case 'profile':
      return <Profile colour={colour} {...props} />;
    case 'tariff':
      return <Tariff colour={colour} {...props} />;
    case 'tdas':
      return <TDAS colour={colour} {...props} />;
    case 'password':
      return <Password colour={colour} {...props} />;
    case 'delete-account':
      return <DeleteAccount colour={colour} {...props} />;
    case 'solar':
      return <Solar colour={colour} {...props} />;
    case 'settings':
      return <Settings colour={colour} {...props} />;
    default:
      // Error handling for unknown icons
      console.warn(`Unknown icon key: "${icon}". Available icons: ${AVAILABLE_ICON_KEYS.join(', ')}`);
      return null;
  }
};

export default Icon;
